import SiteLayout from "../components/SiteLayout";
import { companyParagraphs } from "../data/siteContent";

const CompanyPage = () => {
  return (
    <SiteLayout>
      <div className="page-shell" data-testid="company-page">
        <section className="content-grid content-grid--company-simple">
          <div>
            <div className="eyebrow stagger-1" data-testid="company-page-eyebrow">
              Company
            </div>
            <h1 className="page-title stagger-2" data-testid="company-page-title">
              About Hailo Digital
            </h1>
            <p className="page-intro stagger-3" data-testid="company-page-intro">
              Hailo Digital is a technology company focused on building intelligent digital products and modern software systems.
            </p>
          </div>

          <article className="section-card stagger-4" data-testid="company-content-card">
            <p className="section-copy" data-testid="company-content-copy">
              {companyParagraphs.slice(1).join(" ")}
            </p>
          </article>
        </section>
      </div>
    </SiteLayout>
  );
};

export default CompanyPage;